import api from "./api"

export const getStockTransfers = async () => {
  const response = await api.get("/stock-transfers")
  return response.data
}

export const getStockTransferById = async (transferId) => {
  const response = await api.get(`/stock-transfers/${transferId}`)
  return response.data
}

export const getStockTransferFormData = async () => {
  const response = await api.get("/stock-transfers/form-data")
  return response.data
}

export const createStockTransfer = async (payload) => {
  const response = await api.post("/stock-transfers", payload)
  return response.data
}

export const updateStockTransfer = async (transferId, payload) => {
  const response = await api.put(`/stock-transfers/${transferId}`, payload)
  return response.data
}

export const deleteStockTransfer = async (transferId) => {
  const response = await api.delete(`/stock-transfers/${transferId}`)
  return response.data
}